__turbopack_context__.v({
  "capped": "UAKasq_capped",
  "clearButton": "UAKasq_clearButton",
  "input": "UAKasq_input" + " " + __turbopack_context__.i(232183)["field"],
  "inputClearable": "UAKasq_inputClearable",
  "inputShell": "UAKasq_inputShell",
  "width--10ch": "UAKasq_width--10ch",
  "width--20ch": "UAKasq_width--20ch",
  "width--2ch": "UAKasq_width--2ch",
  "width--30ch": "UAKasq_width--30ch",
  "width--3ch": "UAKasq_width--3ch",
  "width--4ch": "UAKasq_width--4ch",
  "width--5ch": "UAKasq_width--5ch",
});
